import theme from 'src/styles/theme'
import styled from 'styled-components'

export const ActionButton = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: ${theme.colors.darkGray};
`
